const style = ({ COLORS }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    '& a': {
      color: 'inherit',
      textDecoration: 'underline'
    }
  },
  head: ({ size }) => ({
    padding: `${size(3.5)} ${size(4)}`
  }),
  bodyHolder: {
    position: 'relative',
    flex: '1',
    overflow: 'hidden'
  },
  body: ({ size }) => ({
    padding: `${size(3.5)} ${size(4)}`,
    color: COLORS.TEXT.DARK_GREY.NORMAL,
    height: '100%',
    overflowY: 'auto'
  })
})

export default style
